import { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  Toolbar,
  Link as MuiLink,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Menu as MenuIcon, X, Sun, Moon } from 'lucide-react';
import { ThemeToggleContext } from '../App';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const { toggleTheme, mode } = useContext(ThemeToggleContext);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleNavigate = (path: string) => {
    setMobileOpen(false);
    navigate(path);
  };

  // const navLinks = [{ label: 'Contact', path: '/contact' }];

  return (
    <AppBar
      position="sticky"
      color="default"
      elevation={0}
      sx={{
        bgcolor: 'background.default',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          {/* Logo */}
          <MuiLink
            component={Link}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <Box
              component="img"
              src={ mode === "light" ? "/logo-light.png" : "/logo-dark.png"}
              alt="ProdRelease Logo"
              sx={{
                height: { xs: 50, md: 100 },
                width: 'auto',
              }}
            />
          </MuiLink>

          {/* Desktop Navigation */}
          {!isMobile ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <Button
                component={Link}
                to="/contact"
                variant="contained"
                color="primary"
                sx={{ textTransform: 'none' }}
              >
                Book Consultation
              </Button>

              <IconButton
                color="inherit"
                aria-label="toggle theme"
                onClick={toggleTheme}
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  borderRadius: '12px',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    borderColor: 'primary.main',
                    bgcolor: 'rgba(30, 185, 128, 0.1)',
                  },
                }}
              >
                {mode === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
              </IconButton>
            </Box>
          ) : 
          (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton
                color="inherit"
                aria-label="toggle theme"
                onClick={toggleTheme}
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  borderRadius: '12px',
                }}
              >
                {mode === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
              </IconButton>

              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerToggle}
              >
                <MenuIcon size={24} />
              </IconButton>
            </Box>
          )}
        </Toolbar>
      </Container>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: 280,
            bgcolor: 'background.paper',
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
            <IconButton onClick={handleDrawerToggle}>
              <X size={24} />
            </IconButton>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Button
              onClick={() => handleNavigate('/contact')}
              variant="contained"
              color="primary"
              sx={{ textTransform: 'none', mt: 2 }}
            >
              Book Consultation
            </Button>
          </Box>
        </Box>
      </Drawer>
    </AppBar>
  );
}
